export default "__VITE_PUBLIC_ASSET__346c4e8a__"